/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Statistics from "views/Statistics/Statistics";
import Providers from "views/Providers/Providers.jsx";
import ProviderForm from "views/Providers/ProviderForm.jsx";
import Questionnaire from "views/Questionnarie/Questionnaire";
import QuestionnaireViewUpdate from "views/Questionnarie/QuestionnaireViewUpdate";
import Schedule from "views/Schedule.jsx";
import CallReports from "views/CallReports.jsx";
import CallTakers from "views/CallTakers.jsx";
import Users from "views/Users/ManageUsers";
import TextBlast from "views/TextBlast/TextBlastForm";
import ReturnCall from "views/ReturnCall.jsx";
import ReturnCalls from "views/ReturnCalls.jsx";
import UserForm from "views/Users/UserForm";
import Briefings from "views/BriefingRoom/Briefings/Briefings";
import BriefingForm from "views/BriefingRoom/BriefingForm/BriefingForm";
import LessonList from "views/Lessons/LessonList";
import LessonDetail from "views/Lessons/LessonDetail";
import LessonForm from "views/Lessons/LessonForm";
import LessonSummary from "views/Lessons/LessonSummary";
import Recognitions from "views/HonorWall/Recognitions/";
import VoicemailPlayer from "views/VoicemailPlayer";

const HUB_URL = "https://sites.google.com/copline.org/copline-hub";

const routes = [
  {
    path: "/briefing-room",
    layout: "/admin",
    name: "Briefing Room",
    icon: "pe-7s-global",
    component: Briefings,
  },
  {
    path: "/questionnaire",
    layout: "/admin",
    name: "Call Entry Form",
    icon: "pe-7s-note2",
    component: Questionnaire,
  },
  {
    path: "/professional-development",
    layout: "/admin",
    name: "Prof. Development",
    icon: "pe-7s-display1",
    component: LessonList,
  },
  {
    path: "/view-call-entry/:id/",
    layout: "/admin",
    name: "View Call Entry",
    icon: "pe-7s-note2",
    hidden: true,
    component: QuestionnaireViewUpdate,
  },
  {
    path: "/call_report_list",
    layout: "/admin",
    name: "Call Taker Entries",
    icon: "pe-7s-notebook",
    component: CallReports,
  },
  {
    path: "/add-provider",
    layout: "/admin",
    name: "Add Provider",
    icon: "pe-7s-id",
    component: ProviderForm,
  },
  {
    path: "/provider/:id",
    layout: "/admin",
    name: "Provider Details",
    hidden: true,
    component: ProviderForm,
  },
  {
    path: "/providers",
    layout: "/admin",
    name: "Provider List",
    icon: "pe-7s-call",
    component: Providers,
  },
  {
    path: "/call-takers",
    layout: "/admin",
    name: "Call Taker Roster",
    icon: "pe-7s-users",
    component: CallTakers,
  },
  {
    path: "/return-calls",
    layout: "/admin",
    name: "Return Call List",
    icon: "pe-7s-hourglass",
    component: ReturnCalls,
  },
  {
    path: "/return-call",
    layout: "/admin",
    name: "Return Call Follow Up",
    icon: "pe-7s-hourglass",
    hidden: true,
    component: ReturnCall,
  },
  {
    path: "/statistics",
    layout: "/admin",
    name: "Statistics",
    icon: "pe-7s-graph1",
    component: Statistics,
  },
  {
    path: "/schedule",
    layout: "/admin",
    name: "Schedule",
    icon: "pe-7s-date",
    component: Schedule,
  },
  {
    name: "The Hub",
    icon: "pe-7s-link",
    externalUrl: HUB_URL,
  },
  {
    collapse: true,
    name: "Wall of Honor",
    state: "openHonorWall",
    icon: "pe-7s-star",
    views: [
      {
        path: "/honor-wall/recognitions",
        layout: "/admin",
        name: "Honor Wall",
        icon: "pe-7s-medal",
        component: Recognitions,
      },
    ]
  },
  {
    collapse: true,
    path: "/users",
    name: "Admin",
    state: "openAdmin",
    icon: "pe-7s-lock",
    views: [
      {
        path: "/userform",
        layout: "/admin",
        name: "Add User",
        mini: "AU",
        component: UserForm,
      },
      {
        path: "/user/:id",
        layout: "/admin",
        name: "User Details",
        component: UserForm,
        hidden: true,
      },
      {
        path: "/users",
        layout: "/admin",
        name: "Manage Users",
        mini: "MU",
        component: Users,
      },
      {
        path: "/textblast",
        layout: "/admin",
        name: "Text Blast",
        mini: "TB",
        component: TextBlast,
      },
    ],
  },
  {
    path: "/create-briefing",
    layout: "/admin",
    name: "Add Briefing",
    icon: "pe-7s-id",
    hidden: true,
    component: BriefingForm,
  },
  {
    path: "/briefing/:id",
    layout: "/admin",
    name: "Briefing Details",
    hidden: true,
    component: BriefingForm,
  },
  {
    path: "/create-module/:id",
    layout: "/admin",
    name: "Edit Module",
    hidden: true,
    component: LessonForm,
  },
  {
    path: "/create-module",
    layout: "/admin",
    name: "Create Module",
    icon: "pe-7s-id",
    hidden: true,
    component: LessonForm,
  },
  {
    path: "/module/:id/summary",
    layout: "/admin",
    name: "Module Summary",
    hidden: true,
    component: LessonSummary,
  },
  {
    path: "/module/:id",
    layout: "/admin",
    name: "Module Details",
    hidden: true,
    component: LessonDetail,
  },
  {
    path: "/voicemail/:id",
    layout: "/admin",
    name: "Voicemail Player",
    hidden: true,
    component: VoicemailPlayer,
  },
];
export default routes;
